import { Model, hasMany } from 'miragejs'

import type { ModelDefinition } from 'miragejs/-types'

export type UploadGroupData = Record<string, never>

export const model = (Model as ModelDefinition<UploadGroupData>).extend({
  uploads: hasMany('upload'),
})
